import {
  createDisplay,
  DEFAULT_LOCALE,
  DEFAULT_UNIT_SYSTEM,
  normalizeLocale,
  normalizeUnitSystem,
  unitSystemForLanguage,
} from "@plaatplan/i18n";

export const LOCALE_PREFERENCES_KEY = "plaatplan.localePreferences";

/**
 * @typedef {{ locale: string, unitSystem: import("@plaatplan/i18n").UnitSystem }} LocalePreferences
 */

function getDeviceLanguage() {
  return navigator.language?.split("-")[0] ?? "nl";
}

/** @returns {LocalePreferences} */
export function defaultLocalePreferences(deviceLanguage = getDeviceLanguage()) {
  const locale = normalizeLocale(deviceLanguage);
  return {
    locale,
    unitSystem: unitSystemForLanguage(locale) || DEFAULT_UNIT_SYSTEM,
  };
}

/** @returns {LocalePreferences} */
export function loadLocalePreferences() {
  try {
    const raw = window.localStorage.getItem(LOCALE_PREFERENCES_KEY);
    if (!raw) {
      return defaultLocalePreferences();
    }

    const parsed = JSON.parse(raw);
    return {
      locale: normalizeLocale(parsed.locale ?? DEFAULT_LOCALE),
      unitSystem: normalizeUnitSystem(parsed.unitSystem ?? DEFAULT_UNIT_SYSTEM),
    };
  } catch {
    return defaultLocalePreferences();
  }
}

/** @param {LocalePreferences} preferences */
export function saveLocalePreferences(preferences) {
  window.localStorage.setItem(LOCALE_PREFERENCES_KEY, JSON.stringify({
    locale: normalizeLocale(preferences.locale),
    unitSystem: normalizeUnitSystem(preferences.unitSystem),
  }));
}

/** @param {LocalePreferences} preferences */
export function createDisplayFromPreferences(preferences) {
  return createDisplay(preferences);
}
